var React = require('react');

function IconPlay (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.726562 12.3139V23.9217L20.805 12.3139L0.726562 0.706055V12.3139Z"}));
}

IconPlay.defaultProps = {"width":"21","height":"24","viewBox":"0 0 21 24"};

module.exports = IconPlay;

IconPlay.default = IconPlay;
